import React from 'react';
import CommuniquesFeed from '../../components/features/events/CommuniquesFeed';

export default function CommuniquesPage() {
  return (
    <div className="space-y-6 animate-fade-in px-4">
      <div className="text-center space-y-2 max-w-3xl mx-auto">
        <h1 className="font-title text-3xl sm:text-4xl font-extrabold text-acem-primary-dark">
          Communiqués & Annonces Officiels
        </h1>
        <p className="text-sm sm:text-base text-acem-muted">
          Retrouvez l'ensemble des communiqués, notes d'information et annonces diffusés par le Bureau Régional de l'ACEM Fès.
        </p>
      </div>

      <CommuniquesFeed />
    </div>
  );
}
